import { EventEmitterInterface } from 'pf-frontend-common/dist/module/event/emitter.interface';
import { ModalViewEvent } from 'pf-frontend-common/dist/module/modal/view.event';
import { ModalServiceInterface } from 'pf-frontend-common/dist/service/modal/service.interface';

import { DataStore } from 'common/module/data/store';
import { PropertyCtaInteractionEvent } from 'common/module/property-cta/interaction.event';
import { PropertyCtaStatechartActionEnum } from 'common/module/property-cta/statechart/action.enum';
import { PropertyCtaStatechartPayloadInterface } from 'common/module/property-cta/statechart/payload.interface';
import { StatechartStoreInterface } from 'common/module/statechart/store.interface';
import { UserAuthenticationEvent } from 'common/module/user/authentication.event';
import { UserAuthenticationServiceInterface } from 'common/service/user-authentication/service.interface';
import { LeadPhoneTemplatePropsInterface } from 'mobile/module/lead/phone/template-props.interface';

export class LeadPhoneViewStore extends DataStore<LeadPhoneTemplatePropsInterface> {
  /**
   * Constructor
   */
  constructor(
    eventEmitter: EventEmitterInterface,
    private propertyCtaStatechartStore: StatechartStoreInterface,
    private userAuthenticationService: UserAuthenticationServiceInterface,
    private modalService: ModalServiceInterface
  ) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(options: Partial<LeadPhoneTemplatePropsInterface>): void {
    this.state = {
      ...this.getState(),
      isFeedbackRequired: false,
      onClickClose: this.onClickClose,
      isAuthModelOpen: false,
      setAuthPopupVisibility: this.setAuthPopupVisibility,
      ...options,
    };

    this.observers();
  }

  /**
   * Open the phone lead popup
   */
  public openPhoneLeadPopup = (
    model: LeadPhoneTemplatePropsInterface['model'],
    phones: LeadPhoneTemplatePropsInterface['phones'],
    isFeedbackRequired?: LeadPhoneTemplatePropsInterface['isFeedbackRequired']
  ) => {
    this.setState({
      ...this.getState(),
      model,
      phones,
      isOpen: true,
      isFeedbackRequired,
    });
  };

  private setAuthPopupVisibility = (visibility: boolean) => {
    this.setState({
      ...this.getState(),
      isAuthModelOpen: visibility,
    });
  };

  public openAuthPopup = () => {
    this.setAuthPopupVisibility(true);
  };

  /**
   * Open the popup
   */
  public open = () => {
    this.setState({
      ...this.getState(),
      isOpen: true,
      isFeedbackRequired: false,
    });
  };

  /**
   * Close the popup
   */
  public close = () => {
    // Close modal
    this.setState({
      ...this.getState(),
      isOpen: false,
    });
  };

  /**
   * Attach observers
   */
  private observers(): void {
    this.propertyCtaStatechartStore
      .getEventEmitter()
      .addListener(PropertyCtaStatechartActionEnum.openPhoneLeadPopup, this.onOpenPhoneLeadPopup);

    this.userAuthenticationService
      .getEventEmitter()
      .addListener(UserAuthenticationEvent.registrationSucceeded, this.onRegistrationSucceeded);

    this.userAuthenticationService
      .getEventEmitter()
      .addListener(UserAuthenticationEvent.signInSucceeded, this.onSignInSucceeded);

    this.modalService.getEventEmitter().addListener(ModalViewEvent.close, this.onCloseModal);
  }

  /**
   * Close modal when user sign in succeeded
   */
  private onSignInSucceeded = () => {
    this.close();
  };

  /**
   * Close modal when user register succeeded
   */
  private onRegistrationSucceeded = () => {
    this.close();
  };

  /**
   * Handle openPhoneLeadPopup statechart action
   */
  private onOpenPhoneLeadPopup = (payload: PropertyCtaStatechartPayloadInterface) => {
    let phone = null;

    if (payload.interactionEvent === PropertyCtaInteractionEvent.propertyPageCallClick) {
      phone =
        payload.propertyModel.meta.contact_options.details?.phone?.value ||
        payload.propertyModel.meta.contact_options.all.phone.value;
    } else {
      phone = payload.propertyModel.meta.contact_options.list.phone.value;
    }

    this.openPhoneLeadPopup(payload.propertyModel, [phone]);
  };

  /**
   * Clicked on the lead phone close button
   */
  private onClickClose = () => {
    this.close();
  };

  /**
   * Handle modal closing by user
   */
  private onCloseModal = () => {
    this.close();
  };
}
